export default __webpack_public_path__ + "static/media/cartao.6d8ffbb4.mp4";